import React from 'react';
import { Text, Box } from '@chakra-ui/react';

// Function to truncate the text after a certain number of characters
const truncateText = (text, maxLength) => {
    text = text?.replace(/<[^>]*>/g, ' ').replace(/&[a-z]+;/g, ' ');
    if (text?.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
};

function TruncatedText({ content, maxLength = 200, color }) {

    return (
        <Box>
            <Text color={color}>
                {truncateText(content, maxLength)}
            </Text>
        </Box>
    );
}

export default TruncatedText;
